import { enqueueSnackbar } from 'notistack';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SavedFilter } from '@/entities/saved-filter';

import { savedFiltersOptions } from '../savedFilters.options';
import { deleteSavedFilterFromApi, invalidateAndBroadcast } from './savedFiltersMutation.api';

export const useDeleteFilterMutation = () => {
  const queryClient = useQueryClient();
  const queryKey = savedFiltersOptions.all();

  return useMutation({
    mutationKey: savedFiltersOptions.mutations.delete(),

    mutationFn: (id: string) => deleteSavedFilterFromApi(id),

    onMutate: async (id: string) => {
      await queryClient.cancelQueries({ queryKey });
      const previous = queryClient.getQueryData<SavedFilter[]>(queryKey);
      const removedName = previous?.find(filter => filter.id === id)?.name;
      queryClient.setQueryData(queryKey, previous?.filter(filter => filter.id !== id) ?? []);
      return { previous, removedName };
    },

    onSuccess: async (_data, _id, context) => {
      enqueueSnackbar(
        context?.removedName ? `"${context.removedName}" removed` : 'Filter removed',
        {
          variant: 'success'
        }
      );
      await invalidateAndBroadcast(queryClient);
    },

    onError: (_error, _id, context) => {
      if (context?.previous) queryClient.setQueryData(queryKey, context.previous);
      enqueueSnackbar('Something went wrong removing your filter', { variant: 'error' });
    }
  });
};
